import React, { useContext } from "react";
import { Link } from "react-router-dom";
import estilo from "./styles/Terminados.module.css";
import { DataContext } from "../context/DataContext";

function Terminados({ terminados }) {
  if (terminados.sinopsis.length > 0) {
    // var resultado = terminados.sinopsis.substring(0, 22) + "...";
    var resultado1 =
      terminados.sinopsis.split(" ").slice(0, 8).join(" ") + "...";

    var resultado2 =
      terminados.sinopsis.split(" ").slice(0, 16).join(" ") + "...";

    var resultado3 =
      terminados.sinopsis.split(" ").slice(0, 25).join(" ") + "...";
  }

  const { setData, setCambio } = useContext(DataContext);

  return (
    <div className={estilo.terminados}>
      <div className={estilo.portada}>
        <Link to={"/" + terminados.uid}>
          <img src={terminados.portada} alt={terminados.nombre} />
        </Link>
      </div>

      <div className={estilo.informacion}>
        <Link to={"/" + terminados.uid}>
          <h4>{terminados.nombre.split(" ").slice(0, 5).join(" ") + "..."}</h4>
          <p className={estilo.resultado1}>{resultado1}</p>
          <p className={estilo.resultado2}>{resultado2}</p>
          <p className={estilo.resultado3}>{resultado3}</p>
        </Link>
        <div className={estilo.generos}>
          {terminados.generos.map((e, i) => (
            <Link
              to={"/animes"}
              key={i}
              onClick={() => setData(e.genero) || setCambio(false)}
            >
              <p>{e.genero}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Terminados;
